import { useIdFilter } from "shared-ts/hooks/useFilter"
import { stringComparator } from "shared-ts/utils/sorting/comparators"

import { useListProductCategoriesForCompanyV2Query } from "features/api/company"
import { finelineFilterKey } from "hooks/filters/filterKeys"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export { finelineFilterKey }

export function useFinelineFilter({
  persistInUrl = true,
}: Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl">> = {}) {
  const { data } = useListProductCategoriesForCompanyV2Query({})

  const { filter, selected: selectedFinelineIds } = useIdFilter({
    key: finelineFilterKey,
    label: "Fineline",
    values: data?.finelines ?? [],
    sort: stringComparator((category) => category.name),
    labelExtractor: (fineline) => fineline.name,
    useFilter: (props) => useWebFilter({ ...props, persistInUrl }),
  })

  return { filter, selectedFinelineIds }
}
